import { render, staticRenderFns } from "./DetailConfigDatasetGroupListItemAdd.vue?vue&type=template&id=afd36436&scoped=true"
import script from "./DetailConfigDatasetGroupListItemAdd.vue?vue&type=script&lang=js"
export * from "./DetailConfigDatasetGroupListItemAdd.vue?vue&type=script&lang=js"
import style0 from "./DetailConfigDatasetGroupListItemAdd.vue?vue&type=style&index=0&id=afd36436&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd36436",
  null
  
)

export default component.exports